// extracted by mini-css-extract-plugin
export default {"root":"cart-modal_root__b4SkS","modal":"cart-modal_modal__EQqsY","list":"cart-modal_list__9KJUy","total":"cart-modal_total__XSGN+","close":"cart-modal_close__4uwaa"};